import { Dropdown as Root } from './Dropdown';
import { Item } from './Item';
import { Menu } from './Menu';

export const Dropdown = Object.assign(Root, { Menu, Item });
